import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-host-institution',
  templateUrl: './host-institution.component.html',
  styleUrls: ['./host-institution.component.css'],
})
export class HostInstitutionComponent implements OnInit {
  hostinstitution: FormGroup;
  showInMenu = 'true';

  private saveApi = environment.url + 'coe/hostinstitution/save';
  private getApi = environment.url + 'coe/hostinstitution/get?id=';
  private sector = environment.url + 'dropdownvalues/get?key=sectors';
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialog: MatDialog
  ) {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    this.hostinstitution = this.fb.group({
      id: [0],
      applicationId: [sessionStorage.getItem('applicationId')],
      address: ['', [Validators.required]],
      hostInstitutionAplicable: [true, [Validators.required]],
      incubationCentreAplicable: [true, [Validators.required]],
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ],
      ],

      email: ['', [Validators.required, Validators.pattern(emailPattern)]],
      website: ['', [Validators.required, this.urlValidator()]],
      hostInstitution: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z./ ]*$')],
      ],
      hiCertificate: [''],
      hiCertificateDoc: [''],
      incubationCentre: [
        '',
        [Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z./ ]*$')],
      ],
      registrationNumber: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9/][a-zA-Z0-9/]*$'),
        ],
      ],
      sector: ['', Validators.required],
      registrationCertificate: [''],
      registrationCertificateDoc: [''],
    });
  }
  get setting() {
    return this.hostinstitution.controls;
  }
  // get data
  ngOnInit(): void {
    this.getDataApi();
    this.sectorApi();
  }
  // Prevent the Enter key from submitting the form
  preventEnterKey(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
  // onShowInMenuChange
  onShowInMenuChange(value) {
    this.showInMenu = value;
    if (value === 'true') {
      this.hostinstitution
        .get('hostInstitution')
        .setValidators([
          Validators.required,
          Validators.pattern('^[a-zA-Z ]*$'),
        ]);
      this.hostinstitution.get('address').setValidators([Validators.required]);
      this.hostinstitution
        .get('phone')
        .setValidators([
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10,10}$'),
        ]);
      this.hostinstitution
        .get('email')
        .setValidators([
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
          ),
        ]);
      this.hostinstitution
        .get('website')
        .setValidators([Validators.required, this.urlValidator()]);
    } else {
      // Clear and remove validators if 'No' is selected
      this.hostinstitution.get('hostInstitution').clearValidators();
      this.hostinstitution.get('hostInstitution').setValue('');
      this.hostinstitution.get('address').clearValidators();
      this.hostinstitution.get('address').setValue('');
      this.hostinstitution.get('phone').clearValidators();
      this.hostinstitution.get('phone').setValue('');
      this.hostinstitution.get('email').clearValidators();
      this.hostinstitution.get('email').setValue('');
      this.hostinstitution.get('website').clearValidators();
      this.hostinstitution.get('website').setValue('');
      this.FileName = '';
      this.FileValue = '';
      this.disNames = '';
      this.disName = '';
    }
    this.hostinstitution.get('hostInstitution').updateValueAndValidity();
    this.hostinstitution.get('address').updateValueAndValidity();
    this.hostinstitution.get('phone').updateValueAndValidity();
    this.hostinstitution.get('email').updateValueAndValidity();
    this.hostinstitution.get('website').updateValueAndValidity();
  }
  // onincubationCentreAplicable
  showincubationCentreAplicable = 'true';
  incubationCentreAplicables(value) {
    this.showincubationCentreAplicable = value;
    if (value === 'true') {
      this.hostinstitution
        .get('incubationCentre')
        .setValidators([
          Validators.required,
          Validators.pattern('^[a-zA-Z][a-zA-Z./ ]*$'),
        ]);
      this.hostinstitution
        .get('registrationNumber')
        .setValidators([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9/][a-zA-Z0-9/]*$'),
        ]);
      this.hostinstitution.get('sector').setValidators(Validators.required);
    } else {
      this.hostinstitution.get('incubationCentre').clearValidators();
      this.hostinstitution.get('incubationCentre').setValue('');
      this.hostinstitution.get('registrationNumber').clearValidators();
      this.hostinstitution.get('registrationNumber').setValue('');
      this.hostinstitution.get('sector').clearValidators();
      this.hostinstitution.get('sector').setValue([]);
      this.FileName2 = '';
      this.FileValue2 = '';
      this.disNames2 = '';
      this.disName2 = '';
    }
    this.hostinstitution.get('incubationCentre').updateValueAndValidity();
    this.hostinstitution.get('registrationNumber').updateValueAndValidity();
    this.hostinstitution.get('sector').updateValueAndValidity();
  }
  // onInputChange
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^a-zA-Z0-9@.\-+]/g, '');
  }
  // Custom CIN Validator
  cinValidator(control: AbstractControl): ValidationErrors | null {
    const cinPattern =
      /^[a-zA-Z]{1}[0-9]{5}[a-zA-Z]{2}[0-9]{4}[pP][lL][cC][0-9]{6}$/;
    if (control.value && !cinPattern.test(control.value)) {
      return { invalidCin: true };
    }
    return null;
  }
  districtdataList;
  // Custom URL Validator
  urlValidator() {
    return (control) => {
      const urlPattern =
        /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
      if (control.value && !urlPattern.test(control.value)) {
        return { website: true };
      }
      return null;
    };
  }
  showForm: boolean = false;
  // sector
  sectorApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi.method(this.sector, '', 'get').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      if (data.response.responseStatus == 'Success') {
        this.districtdataList = data.dropDownValues.values;
      }
    });
  }
  getValue: any = {};
  disableBtn: boolean;
  show;
  // get data
  getDataApi() {
    this.getdata.amizhthLoader('show');
    this.makeapi
      .method(this.getApi + sessionStorage.getItem('applicationId'), '', 'get')
      .subscribe((data) => {
        this.getdata.amizhthLoader('hide');

        this.getValue = data;
        if (data.edit === false) {
          this.showForm = true;
        } else {
          this.showForm = false;
        }
        if (data.incubationCentreAplicable == false) {
          this.showincubationCentreAplicable =
            data.incubationCentreAplicable.toString();
          this.incubationCentreAplicables('false');
        }
        if (data.hostInstitutionAplicable == false) {
          this.showInMenu = data.hostInstitutionAplicable.toString();
          this.onShowInMenuChange('false');
        }
        if (data.responseStatus != 'Failed') {
          this.hostinstitution.patchValue(data);
          if (this.getValue.hiCertificateDoc) {
            this.FileValue = this.getValue.hiCertificateDoc;
            this.FileName = this.getValue.hiCertificate;
            this.disNames = '✔ Uploaded';
            this.disName = '✔ Uploaded';
          }
          if (this.getValue.registrationCertificateDoc) {
            this.FileValue2 = this.getValue.registrationCertificateDoc;
            this.FileName2 = this.getValue.registrationCertificate;
            this.disNames2 = '✔ Uploaded';
            this.disName2 = '✔ Uploaded';
          }
        }
      });
  }
  selecetdFile: any = [];
  url: any;
  FileValue: any = '';
  FileName: any;
  documentValues = [];
  disName;
  disNames;
  maxSizeMB = 5;
  logoCheck = false;
  fileErrorShow = false;
  fileError = false;
  // file upload
  fileUpload(event) {
    this.selecetdFile = event.target.files[0];
    if (event.target.files && this.selecetdFile) {
      const fileSizeMB = this.selecetdFile.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile);
        reader.onload = () => {
          this.url = reader.result;
          let spl = this.url.split(',');
          this.FileValue = spl[1];
          this.FileName = this.selecetdFile.name;
          this.disName = '✔ Uploaded';
          this.fileError = false;
          this.fileErrorShow = false;
          this.notify.notifysuccess('File Upload Success !');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  selecetdFile2: any = [];
  url2: any;
  FileValue2: any = '';
  FileName2: any;
  documentValues2 = [];
  disName2;
  disNames2;
  maxSizeMB2 = 5;
  logoCheck2 = false;
  fileErrorShow2 = false;
  fileError2 = false;
  // file upload
  fileUpload2(event) {
    this.selecetdFile2 = event.target.files[0];
    if (event.target.files && this.selecetdFile2) {
      const fileSizeMB = this.selecetdFile2.size / (1024 * 1024);
      if (fileSizeMB > this.maxSizeMB2) {
        this.notify.notifyError('File size exceeds the limit (5MB)');
        return;
      }
      let reader = new FileReader();
      let imagetype = this.selecetdFile2.type;
      let imagedatatype = imagetype.split('/');
      let img_crt_type = imagedatatype[1];
      if (img_crt_type == 'pdf') {
        reader.readAsDataURL(this.selecetdFile2);
        reader.onload = () => {
          this.url2 = reader.result;
          let spl = this.url2.split(',');
          this.FileValue2 = spl[1];
          this.FileName2 = this.selecetdFile2.name;
          this.disName2 = '✔ Uploaded';
          this.fileError2 = false;
          this.fileErrorShow2 = false;
          this.notify.notifysuccess('File Upload Success !');
        };
      } else {
        this.notify.notifyError('Only *pdf format are allowed');
      }
    }
  }
  // cancle
  cancleBtn() {
    this.fileError = true;
    this.FileValue = '';
    this.FileValue2 = '';
    this.FileName = '';
    this.FileName2 = '';
    this.disName = '';
    this.disName2 = '';
    this.fileError2 = true;
    this.fileError = true;
    this.showForm = false;
    this.hostinstitution.reset();
  }
  // save
  saveBtn() {
    if (
      this.showInMenu == 'false' &&
      this.showincubationCentreAplicable == 'false'
    ) {
      this.notify.notifyError('Please Select either one Details');
      return;
    } else if (
      this.showInMenu == 'true' &&
      this.showincubationCentreAplicable == 'true'
    ) {
      this.saveModal();
    } else {
      if (this.hostinstitution.valid) {
        if (this.showInMenu == 'true' && this.fileError == false) {
          document.getElementById('editModals').style.display = 'block';
        } else if (
          this.showincubationCentreAplicable == 'true' &&
          this.fileError2 == false
        ) {
          document.getElementById('editModals').style.display = 'block';
        }
      } else {
        if (
          (this.showInMenu == 'true' && this.FileName == '') ||
          this.FileName == undefined
        ) {
          this.fileError = true;
        }
        if (
          (this.showincubationCentreAplicable == 'true' &&
            this.FileName2 == '') ||
          this.FileName2 == undefined
        ) {
          this.fileError2 = true;
        }
        this.hostinstitution.markAllAsTouched();
        this.notify.notifyError('Please fill all the mandatory fields !!');
      }
    }
  }
  maxSelection = 5;
  // max selection
  onSelectionChange(event: any): void {
    const selectedValues = this.hostinstitution.get('sector')?.value;
    if (selectedValues.length > this.maxSelection) {
      selectedValues.pop();
      this.hostinstitution.get('sector')?.setValue(selectedValues);
    }
  }
  // disable
  isDisabled(option: string): boolean {
    const selectedValues = this.hostinstitution.get('sector')?.value;
    return (
      selectedValues?.length >= this.maxSelection &&
      !selectedValues.includes(option)
    );
  }
  // save
  saveModal() {
    let getform = this.hostinstitution.value;
    if (this.hostinstitution.invalid) {
      if (this.FileValue == '') {
        this.fileError = true;
      } else {
        this.fileError = false;
      }
      if (this.FileValue2 == '') {
        this.fileError2 = true;
      } else {
        this.fileError2 = false;
      }
      this.hostinstitution.markAllAsTouched();
      this.notify.notifyError('Please fill all the mandatory fields !!');
    } else {
      if (this.FileValue != '') {
        this.fileError = false;
        getform.hiCertificate = this.FileName;
        getform.hiCertificateDoc = this.FileValue;
      } else {
        this.fileError = true;
      }
      if (this.FileValue2 != '') {
        this.fileError2 = false;
        getform.registrationCertificate = this.FileName2;
        getform.registrationCertificateDoc = this.FileValue2;
      } else {
        this.fileError2 = true;
      }
      if (this.showInMenu == 'false') {
        this.fileError = false;
        getform.hiCertificate = '';
        getform.hiCertificateDoc = '';
      }
      if (this.showincubationCentreAplicable == 'false') {
        this.fileError2 = false;
        getform.registrationCertificate = '';
        getform.registrationCertificateDoc = '';
      }

      getform.applicationId = sessionStorage.getItem('applicationId');
      if (this.fileError == false && this.fileError2 == false) {
        this.getdata.amizhthLoader('show');
        this.makeapi.method(this.saveApi, getform, 'post').subscribe((data) => {
          this.getdata.amizhthLoader('hide');
          this.fileErrorShow = false;
          this.fileErrorShow2 = false;
          if (data.responseStatus == 'Success') {
            sessionStorage.setItem('applicationId', data.applicationId);
            this.notify.notifysuccess(data.responseMessage);
            this.router.navigateByUrl('/admin/coe/point-of-contact');
          } else {
            this.notify.notifyError(data.responseMessage);
          }
        });
      }
    }
  }
  // close
  closeModal(): void {
    document.getElementById('editModals').style.display = 'none';
  }
}
